module.exports = __webpack_public_path__ + "img/trailer0.7706d4ad.png";